import type { HTMLAttributes, PropsWithChildren } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@eon/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline: 'text-foreground',
        success: 'border-transparent bg-energy-500/15 text-energy-700 dark:text-energy-300',
        warning: 'border-transparent bg-amber-400/15 text-amber-700 dark:text-amber-300',
        info: 'border-transparent bg-electric-400/15 text-electric-700 dark:text-electric-300',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export type BadgeProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & VariantProps<typeof badgeVariants>
>;

export function Badge({ className, variant, children, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props}>
      {children}
    </div>
  );
}

export { badgeVariants };
